import { EditProfilePageComponent } from './pages/edit-profile-page/edit-profile-page.component';
import { EditProfileModalComponent } from './modals/edit-profile-modal/edit-profile-modal.component';
import { EditProfileComponent } from './components/edit-profile/edit-profile.component';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HelpersModule } from '../helpers/helpers.module';
import { AccordionModule } from 'ngx-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        HelpersModule,
        AccordionModule,
        TranslateModule
    ],
    providers: [
    ],
    declarations: [
        EditProfileComponent,
        EditProfileModalComponent,
        EditProfilePageComponent,
    ],
    exports: [
        EditProfileModalComponent,
    ],
})
export class UserModule { }
